import { render, staticRenderFns } from "./sim-management-table.vue?vue&type=template&id=838ce962&scoped=true&"
import script from "./sim-management-table.vue?vue&type=script&lang=js&"
export * from "./sim-management-table.vue?vue&type=script&lang=js&"
import style0 from "./sim-management-table.vue?vue&type=style&index=0&id=838ce962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838ce962",
  null
  
)

export default component.exports